// Korean (`ko`) shell baseline
import { layoutKo } from './ko/layout'
import { homeKo } from './ko/home'
import { playKo } from './ko/play'
import { demoKo } from './ko/demo'
import { booksKo } from './ko/books'
import { commerceKo } from './ko/commerce'
import { communityKo } from './ko/community'
import { dashboardKo } from './ko/dashboard'
import { authKo } from './ko/auth'
import { marketingKo } from './ko/marketing'
import { worldKo } from './ko/world'
import { encyclopediaKo } from './ko/encyclopedia'
import { systemKo } from './ko/system'
import { cityKo } from './ko/city'
import type { MessageCatalog } from '@gamecodex/world-config'

export const baseKo: MessageCatalog = {
  ...layoutKo,
  ...homeKo,
  ...playKo,
  ...demoKo,
  ...booksKo,
  ...commerceKo,
  ...communityKo,
  ...dashboardKo,
  ...authKo,
  ...marketingKo,
  ...worldKo,
  ...encyclopediaKo,
  ...systemKo,
  ...cityKo,
}
